// import React, { useEffect, useState } from "react";
// import {
//   collection,
//   addDoc,
//   Timestamp,
//   getDocs,
//   doc,
//   updateDoc,
//   query,
//   where,
//   orderBy,
// } from "firebase/firestore";
// import { db } from "../firebase";
// import { useSelector } from "react-redux";
// import "../css/mails.css";

// const Mails = () => {
//   const currentTheme = useSelector((state) => state.theme.current);

//   const [data, setData] = useState({
//     details: "",
//     status: "pending",
//     booked: "",
//   });

//   const [mails, setMails] = useState([]);
//   const [booked, setBooked] = useState("");
//   const [filtered, setFiltered] = useState([]);
//   const [pages, setPages] = useState(1);

//   let FormsPerPage = 3;
//   let noOfForms = mails.length;
//   let totalForms = Math.ceil(noOfForms / FormsPerPage);
//   let start = (pages - 1) * FormsPerPage;
//   let pagination = mails.slice(start, start + FormsPerPage);

//   const [selected, setSelected] = useState({
//     primary: "", // status
//     secondary: "", // bookedBy
//     sort: "desc", // default newest first
//     month: "", // month filter
//     year: "",
//   });

//   // ================= ADD Mails =================
//   const addMails = async () => {
//     if (!data.details.trim()) return alert("Enter Details");

//     await addDoc(collection(db, "Mails"), {
//       date: Timestamp.now(),
//       details: data.details,
//       status: data.status || "pending",
//       bookedBy: data.booked || "",
//     });

//     setData({
//       details: "",
//       status: "pending",
//       booked: "",
//     });
//   };

//   // ================= UPDATE STATUS =================
//   const updateStatus = async (id, status) => {
//     try {
//       const docRef = doc(db, "Mails", id);
//       await updateDoc(docRef, { status });

//       setMails((prev) =>
//         prev.map((item) => (item.id === id ? { ...item, status } : item)),
//       );
//     } catch (error) {
//       alert("Operation not allowed for viewers");
//     }
//   };

//   // ================= UPDATE BOOKEDBY =================
//   const updateBookedBy = async (id, booked) => {
//     try {
//       const docRef = doc(db, "Mails", id);
//       await updateDoc(docRef, { bookedBy: booked });
//       setBooked(booked);
//     } catch (error) {
//       alert("Operation not allowed for viewers");
//     }
//   };

//   // ================= FETCH FILTERED DATA =================
//   useEffect(() => {
//     const fetchFilteredMails = async () => {
//       const baseRef = collection(db, "Mails");
//       let conditions = [];

//       if (selected.primary) {
//         conditions.push(where("status", "==", selected.primary));
//       }

//       if (selected.secondary) {
//         conditions.push(where("bookedBy", "==", selected.secondary));
//       }

//       let q = query(
//         baseRef,
//         ...conditions,
//         orderBy("date", selected.sort === "asc" ? "asc" : "desc"),
//       );

//       const snapshot = await getDocs(q);

//       let data = snapshot.docs.map((doc) => ({
//         id: doc.id,
//         ...doc.data(),
//       }));

//       // Month filtering (client side because Firestore needs range query for month)
//       if (selected.month) {
//         data = data.filter((item) => {
//           const month = item.date?.toDate().toLocaleString("default", {
//             month: "long",
//           });
//           return month === selected.month;
//         });
//       }

//       if (selected.year) {
//         data = data.filter((item) => {
//           const year = item.date?.toDate().getFullYear();
//           return year.toString() === selected.year;
//         });
//       }

//       setMails(data);
//     };

//     fetchFilteredMails();
//   }, [selected, booked]);

//   return (
//     <div className="mails-container">
//       <h2>Contact Mails</h2>

//       {/* ================= FILTERS ================= */}
//       <div className="filter-container">
//         {/* STATUS FILTER */}
//         <select
//           className="filter-select"
//           value={selected.primary}
//           onChange={(e) =>
//             setSelected((prev) => ({ ...prev, primary: e.target.value }))
//           }
//         >
//           <option value="">All Status</option>
//           <option value="pending">Pending</option>
//           <option value="done">Done</option>
//         </select>

//         {/* BOOKEDBY FILTER */}
//         <select
//           className="filter-select"
//           value={selected.secondary}
//           onChange={(e) =>
//             setSelected((prev) => ({ ...prev, secondary: e.target.value }))
//           }
//         >
//           <option value="">All BookedBy</option>
//           <option value="Ahmad Raza Najmuddin">Ahmad Raza Najmuddin</option>
//           <option value="zain">Zain</option>
//           <option value="abbas mirza">Abbas Mirza</option>
//           <option value="ali mohammad">Ali Mohammad</option>
//           <option value="hussain">Hussain</option>
//           <option value="mahdi">Mahdi</option>
//           <option value="arsalan">Arsalan</option>
//           <option value="ali mehdi">Ali Mehdi</option>
//           <option value="ali abbas">Ali Abbas</option>
//         </select>

//         {/* SORT BY DATE */}
//         <select
//           className="filter-select"
//           value={selected.sort}
//           onChange={(e) =>
//             setSelected((prev) => ({ ...prev, sort: e.target.value }))
//           }
//         >
//           <option value="desc">Newest First</option>
//           <option value="asc">Oldest First</option>
//         </select>

//         {/* MONTH FILTER */}
//         <select
//           className="filter-select"
//           value={selected.month}
//           onChange={(e) =>
//             setSelected((prev) => ({ ...prev, month: e.target.value }))
//           }
//         >
//           <option value="">All Months</option>
//           {[
//             ...new Set(
//               mails.map((v) =>
//                 v.date?.toDate().toLocaleString("default", { month: "long" }),
//               ),
//             ),
//           ].map((month) => (
//             <option key={month} value={month}>
//               {month}
//             </option>
//           ))}
//         </select>

//         <select
//           className="filter-select"
//           value={selected.year}
//           onChange={(e) =>
//             setSelected((prev) => ({ ...prev, year: e.target.value }))
//           }
//         >
//           <option value="">All Years</option>
//           {[...new Set(mails.map((v) => v.date?.toDate().getFullYear()))].map(
//             (year) => (
//               <option key={year} value={year}>
//                 {year}
//               </option>
//             ),
//           )}
//         </select>
//       </div>

//       <div className="total-form-count">Total Forms: {mails.length}</div>

//       <div className="pagination">
//         <button disabled={pages === 1} onClick={() => setPages(pages - 1)}>
//           Prev
//         </button>
//         {(() => {
//           const pagess = [];
//           for (let i = 1; i <= totalForms; i++) {
//             pagess.push(
//               <button key={i} onClick={() => setPages(i)}>
//                 {i}
//               </button>,
//             );
//           }
//           return pagess;
//         })()}
//         <button
//           disabled={pages === totalForms}
//           onClick={() => setPages(pages + 1)}
//         >
//           Next
//         </button>
//       </div>

//       {/* ================= DISPLAY ================= */}
//       <div className="mails-card">
//         {pagination.map((mails) => (
//           <div
//             key={mails.id}
//             className="mails-content"
//             style={{
//               backgroundColor: currentTheme,
//               color:
//                 mails.status === "pending"
//                   ? "red"
//                   : mails.status === "done"
//                     ? "green"
//                     : "",
//             }}
//           >
//             <button
//               className="pending"
//               onClick={() => updateStatus(mails.id, "pending")}
//             >
//               Pending
//             </button>

//             <button
//               className="done"
//               onClick={() => updateStatus(mails.id, "done")}
//             >
//               Done
//             </button>

//             <p style={{ color: "white" }}>
//               Date: {mails.date?.toDate().toLocaleString()}
//             </p>

//             {/* <p>Detail: {mails.details}</p> */}

//             <p>Name: {mails.details?.name}</p>
//             <p>Email: {mails.details?.email}</p>
//             <p>Phone: {mails.details?.phone}</p>
//             <p>Subject: {mails.details?.subject}</p>
//             <p>Message: {mails.details?.message}</p>

//             <select
//               style={{ color: "white", background: "black" }}
//               value={mails.bookedBy || ""}
//               onChange={(e) => updateBookedBy(mails.id, e.target.value)}
//             >
//               <option value="">Choose</option>
//               <option value="Ahmad Raza Najmuddin">Ahmad Raza Najmuddin</option>
//               <option value="zain">Zain</option>
//               <option value="abbas mirza">Abbas Mirza</option>
//               <option value="ali mohammad">Ali Mohammad</option>
//               <option value="hussain">Hussain</option>
//               <option value="mahdi">Mahdi</option>
//               <option value="arsalan">Arsalan</option>
//               <option value="ali mehdi">Ali Mehdi</option>
//               <option value="ali abbas">Ali Abbas</option>
//             </select>

//             <p style={{ color: "white" }}>Booked By: {mails.bookedBy}</p>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Mails;


import React, { useEffect, useState } from "react";
import {
  collection, getDocs, doc, updateDoc, query, where, orderBy,
} from "firebase/firestore";
import { db } from "../firebase";
import { toast, ToastContainer } from "react-toastify";
import "../css/datapanel.css";

const STATUS_OPTIONS = ["pending", "done"];
const STATUS_COLORS  = { pending:"#f39c12", done:"#27ae60" };

const VOLUNTEERS = [
  "Ahmad Raza Najmuddin","zain","abbas mirza","ali mohammad","hussain",
  "mahdi","arsalan","ali mehdi","ali abbas",
];

const Mails = () => {
  const [mails, setMails]             = useState([]);
  const [loading, setLoading]         = useState(true);
  const [search, setSearch]           = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [sortOrder, setSortOrder]     = useState("desc");
  const [expanded, setExpanded]       = useState(null);

  useEffect(() => { fetchMails(); }, [sortOrder]);

  const fetchMails = async () => {
    setLoading(true);
    try {
      const q = query(collection(db, "Mails"), orderBy("date", sortOrder));
      const snap = await getDocs(q);
      setMails(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    } catch (err) { toast.error("Failed to load mails."); }
    setLoading(false);
  };

  const updateStatus = async (id, status) => {
    try {
      await updateDoc(doc(db, "Mails", id), { status });
      setMails(prev => prev.map(m => m.id === id ? { ...m, status } : m));
      toast.success("Status updated.");
    } catch { toast.error("Update failed."); }
  };

  const updateBookedBy = async (id, value) => {
    try {
      await updateDoc(doc(db, "Mails", id), { bookedBy: value });
      setMails(prev => prev.map(m => m.id === id ? { ...m, bookedBy: value } : m));
    } catch (err) { console.error(err); }
  };

  const filtered = mails.filter(m => {
    if (statusFilter !== "all" && m.status !== statusFilter) return false;
    if (search) {
      const s = search.toLowerCase();
      const name    = (m.details?.name || m.details || "").toString().toLowerCase();
      const email   = (m.details?.email || "").toLowerCase();
      const phone   = (m.details?.phone || "").toLowerCase();
      if (!name.includes(s) && !email.includes(s) && !phone.includes(s)) return false;
    }
    return true;
  });

  const formatDate = ts => {
    if (!ts) return "—";
    const d = ts.toDate ? ts.toDate() : new Date(ts);
    return d.toLocaleDateString("en-IN", { day:"2-digit", month:"short", year:"numeric", hour:"2-digit", minute:"2-digit" });
  };

  return (
    <div className="dp-root">
      <ToastContainer />

      {/* Header */}
      <div className="dp-header">
        <div className="dp-header-left">
          <span className="dp-header-icon">📧</span>
          <div>
            <h2 className="dp-title">Contact Mails</h2>
            <p className="dp-subtitle">All messages received from the contact form</p>
          </div>
        </div>
        <button className="dp-refresh-btn" onClick={fetchMails}>↻ Refresh</button>
      </div>

      {/* Stats */}
      <div className="dp-stats-row">
        {["all","pending","done"].map(s => (
          <button
            key={s}
            className={`dp-stat-card ${statusFilter === s ? "dp-stat-active" : ""}`}
            style={{ "--sc": s === "all" ? "#162f06" : STATUS_COLORS[s] }}
            onClick={() => setStatusFilter(s)}
          >
            <span className="dp-stat-count">
              {s === "all" ? mails.length : mails.filter(m => m.status === s).length}
            </span>
            <span className="dp-stat-label">{s === "all" ? "All" : s.charAt(0).toUpperCase()+s.slice(1)}</span>
          </button>
        ))}
      </div>

      {/* Filters */}
      <div className="dp-filters">
        <input
          className="dp-search"
          placeholder="Search by name, email or phone…"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
        <select className="dp-select" value={sortOrder} onChange={e => setSortOrder(e.target.value)}>
          <option value="desc">Newest First</option>
          <option value="asc">Oldest First</option>
        </select>
        <span className="dp-count">{filtered.length} records</span>
      </div>

      {/* List */}
      {loading ? (
        <div className="dp-loading"><div className="dp-spinner" /><p>Loading…</p></div>
      ) : filtered.length === 0 ? (
        <div className="dp-empty"><span>📭</span><p>No mails found.</p></div>
      ) : (
        <div className="dp-list">
          {filtered.map(mail => {
            const isOpen = expanded === mail.id;
            const det = mail.details || {};
            const name = det.name || (typeof det === "string" ? det : "—");
            return (
              <div key={mail.id} className={`dp-card ${isOpen ? "dp-card-open" : ""}`}>
                <div className="dp-card-header" onClick={() => setExpanded(isOpen ? null : mail.id)}>
                  <div className="dp-card-left">
                    <span className="dp-status-pill" style={{ background: STATUS_COLORS[mail.status] || "#999" }}>
                      {mail.status || "pending"}
                    </span>
                    <span className="dp-card-name">{name}</span>
                    <span className="dp-card-sub">{det.email || "—"} · {formatDate(mail.date)}</span>
                  </div>
                  <span className="dp-chevron">{isOpen ? "▲" : "▼"}</span>
                </div>

                {isOpen && (
                  <div className="dp-card-body">
                    <div className="dp-info-grid">
                      <div className="dp-info-item"><span className="dp-info-key">Name</span><span className="dp-info-val">{det.name || "—"}</span></div>
                      <div className="dp-info-item"><span className="dp-info-key">Email</span><span className="dp-info-val">{det.email || "—"}</span></div>
                      <div className="dp-info-item"><span className="dp-info-key">Phone</span><span className="dp-info-val">{det.phone || "—"}</span></div>
                      <div className="dp-info-item"><span className="dp-info-key">Subject</span><span className="dp-info-val">{det.subject || "—"}</span></div>
                      <div className="dp-info-item dp-info-full"><span className="dp-info-key">Message</span><span className="dp-info-val">{det.message || (typeof det === "string" ? det : "—")}</span></div>
                      <div className="dp-info-item"><span className="dp-info-key">Date</span><span className="dp-info-val">{formatDate(mail.date)}</span></div>
                    </div>

                    <div className="dp-controls">
                      <div className="dp-ctrl-group">
                        <label className="dp-ctrl-label">Status</label>
                        <select className="dp-ctrl-select" value={mail.status || "pending"} onChange={e => updateStatus(mail.id, e.target.value)}>
                          {STATUS_OPTIONS.map(s => <option key={s} value={s}>{s.charAt(0).toUpperCase()+s.slice(1)}</option>)}
                        </select>
                      </div>
                      <div className="dp-ctrl-group">
                        <label className="dp-ctrl-label">Assigned To</label>
                        <select className="dp-ctrl-select" value={mail.bookedBy || ""} onChange={e => updateBookedBy(mail.id, e.target.value)}>
                          <option value="">Choose volunteer</option>
                          {VOLUNTEERS.map(v => <option key={v} value={v}>{v.charAt(0).toUpperCase()+v.slice(1)}</option>)}
                        </select>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Mails;